import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  Image,
} from 'react-native';
import { ms, s, vs } from '../utils/responsive';
import { useNavigation } from '@react-navigation/native';
import { RootStackNavigationProp } from '../types/navigation';

export const BottomNavBar: React.FC = () => {
  const navigation = useNavigation<RootStackNavigationProp>();

  return (
    <View
      style={styles.container}
      accessibilityRole="tablist"
      accessibilityLabel="Main navigation"
    >
      <TouchableOpacity
        style={styles.tabItem}
        onPress={() => navigation.reset({
          index: 0,
          routes: [{ name: 'Dashboard' }],
        })}
        accessibilityRole="tab"
        accessibilityLabel="Dashboard"
        accessibilityHint="Navigate to dashboard home screen"
      >
        <Image
          source={require('../assets/icons/dashboard.png')}
          style={styles.icon}
          accessibilityElementsHidden={true}
        />
        <Text style={styles.label}>Dashboard</Text>
      </TouchableOpacity>

      <TouchableOpacity
        style={styles.tabItem}
        onPress={() => navigation.navigate('Dashboard' as never, {
          screen: 'AllTasks'
        } as never)}
        accessibilityRole="tab"
        accessibilityLabel="All Tasks"
        accessibilityHint="View all tasks and checklists"
      >
        <Image
          source={require('../assets/icons/tasks.png')}
          style={styles.icon}
          accessibilityElementsHidden={true}
        />
        <Text style={styles.label}>All Tasks</Text>
      </TouchableOpacity>

      <TouchableOpacity
        style={styles.tabItem}
        onPress={() => navigation.navigate('Documents' as never, {
          screen: 'DocumentsDashboardScreen'
        } as never)}
        accessibilityRole="tab"
        accessibilityLabel="Documents"
        accessibilityHint="View and manage your documents"
      >
        <Image
          source={require('../assets/icons/docs.png')}
          style={styles.icon}
          accessibilityElementsHidden={true}
        />
        <Text style={styles.label}>Docs</Text>
      </TouchableOpacity>

      <TouchableOpacity
        style={styles.tabItem}
        onPress={() => navigation.navigate('Profile')}
        accessibilityRole="tab"
        accessibilityLabel="Account"
        accessibilityHint="View and manage your account settings"
      >
        <Image
          source={require('../assets/icons/profile.png')}
          style={styles.icon}
          accessibilityElementsHidden={true}
        />
        <Text style={styles.label}>Account</Text>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    backgroundColor: '#FFFFFF',
    paddingTop: ms(15),
    paddingBottom: ms(25),
    borderTopWidth: ms(1),
    borderTopColor: '#E5E7EB',
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
  },
  tabItem: {
    alignItems: 'center',
    flex: 1,
  },
  icon: {
    width: s(34),
    height: s(34),
    marginBottom: ms(4),
  },
  label: {
    fontSize: ms(14, 0.3),
    color: '#1C2C4F',
  },
});
